import React, { useEffect, useState } from "react";
import { patchDataToken, postData } from "../axios/axiosHelper";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";

const ChangePassswordHooks = () => {
    let {resetPasswordToken} = useParams()
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [showPassword3, setShowPassword3] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
    });
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    };
  
    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };
    const togglePasswordVisibility2 = () => {
      setShowPassword2(!showPassword2);
    };
    const togglePasswordVisibility3 = () => {
        setShowPassword3(!showPassword3);
    };
  
    const handleLogin = async (e) => {
      e.preventDefault();
      setLoading(true);
      await patchDataToken(`/admin/auth/changePassword`, formData , resetPasswordToken)
        .then((response) => {
            toast.success(response?.data?.message);
            navigate("/login");
        })
        .catch((err) => toast.error(err?.response?.data?.message))
        .finally((_) => setLoading(false));
    };
    return {
      showPassword,
      setShowPassword,
      togglePasswordVisibility,
      formData,
      setFormData,
      loading,
      handleLogin,
      handleInputChange,
      togglePasswordVisibility2,
      showPassword2,
      togglePasswordVisibility3,
      setShowPassword3,
      showPassword3
    };
}

export default ChangePassswordHooks